module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_both_costume-ed601b1be013718664305e0814921f7a.webp";